import { render, staticRenderFns } from "./PatientUploadDocs.vue?vue&type=template&id=d478c93a&scoped=true&"
import script from "./PatientUploadDocs.vue?vue&type=script&lang=js&"
export * from "./PatientUploadDocs.vue?vue&type=script&lang=js&"
import style0 from "./PatientUploadDocs.vue?vue&type=style&index=0&id=d478c93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d478c93a",
  null
  
)

export default component.exports